import React from "react";
import useReportsHistory from "../../Hooks/Reports/useReportsHistory";

const ReportHistory = () => {
  const { reports, totalCount, meta, error, isLoading, reload } = useReportsHistory();

  return (
    <div className="p-6 font-cairo bg-light min-h-screen">
      {/* 🔹 الملخص */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <SummaryCard title="إجمالي التقارير" value={totalCount} />
        <SummaryCard
          title="آخر تحديث"
          value={meta ? new Date(meta.generated_at).toLocaleDateString("en-EG") : "-"}
        />
      </div>

      {/* 🔹 الحالة */}
      {isLoading ? (
        <p className="text-center text-gray-500">جاري تحميل البيانات ...</p>
      ) : error ? (
        <div className="text-center text-accent">
          <p>{error.message || "حدث خطأ ما"}</p>
          <button onClick={reload} className="underline mt-2 text-sm">
            إعادة المحاولة
          </button>
        </div>
      ) : (
        /* 🔹 الجدول */
        <div className="bg-grayish shadow rounded-2xl p-6 animate-fadeUpSmooth">
          <h2 className="text-xl font-semibold text-main1 mb-4">سجل التقارير</h2>
          <div className="overflow-x-auto rounded-2xl">
            <table className="min-w-full text-sm text-main1 font-cairo">
              <thead>
                <tr className="bg-grayish text-main1">
                  <th className="p-4 text-right">نوع التقرير</th>
                  <th className="p-4 text-right">تاريخ الإنشاء</th>
                  <th className="p-4 text-right">تاريخ الانتهاء</th>
                  <th className="p-4 text-center">الحالة</th>
                </tr>
              </thead>
              <tbody>
                {reports.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center py-16 text-gray-500">
                      لا يوجد تقارير مسجلة
                    </td>
                  </tr>
                ) : (
                  reports.map((rep) => (
                    <tr
                      key={rep.id}
                      className="border-b last:border-b-0 hover:bg-grayish/60 transition"
                    >
                      <td className="p-4 text-right font-medium">{rep.report_type}</td>
                      <td className="p-4 text-right">
                        {new Date(rep.generated_at).toLocaleDateString("en-EG")}
                      </td>
                      <td className="p-4 text-right">
                        {new Date(rep.expires_at).toLocaleDateString("en-EG")}
                      </td>
                      <td className="p-4 text-center">
                        <span
                          className={`px-3 py-1 rounded-2xl text-xs font-bold ${
                            rep.is_expired
                              ? "bg-red-100 text-red-600"
                              : "bg-green-100 text-green-600"
                          }`}
                        >
                          {rep.is_expired ? "منتهي" : "ساري"}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

// 🔹 Component لبطاقات الملخص
const SummaryCard = ({ title, value }) => (
  <div className="bg-grayish shadow rounded-2xl p-4 flex flex-col items-center justify-center animate-fadeUpSmooth">
    <p className="text-sm text-gray-500">{title}</p>
    <h3 className="text-xl font-bold text-main1 mt-2">{value}</h3>
  </div>
);

export default ReportHistory;
